module.exports = __webpack_public_path__ + "static/media/graph.fa0923e5.png";